import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EntityRequestDTO } from '../shared/interfaces/request/entity-request-dto';
import { RestApiBase } from '../shared/configurations/rest-api-base.config';

@Injectable({
    providedIn: 'root',
})
export class AccessRequestService {
    protected http = inject(HttpClient);

    getAvailableAccessRightsForRequest() {
        return this.http.get<string[]>(
            RestApiBase.FILE_REQUEST_API + '/availableAccessRightsForRequest',
        );
    }

    getFileRequestPolicy(accessRightId: string) {
        return this.http.get(
            RestApiBase.FILE_REQUEST_API + '/policy/' + accessRightId,
            { responseType: 'text' },
        );
    }

    createFileRequest(requestDTO: EntityRequestDTO) {
        return this.http.post(
            RestApiBase.FILE_REQUEST_API + '/create',
            requestDTO,
        );
    }
}
